import marca from 'assets/img/logo/marca.png';
import React from 'react';

import {

  MdDashboard,

} from 'react-icons/md';

import {FaRegNewspaper, FaBook, FaBullhorn, FaCloudUploadAlt, FaStar, FaBookmark, FaCloudDownloadAlt, FaUserAlt, FaUnlock, FaCogs, FaGraduationCap, FaImages} from 'react-icons/fa'
import { NavLink } from 'react-router-dom';
import {
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import bn from 'utils/bemnames';

import ItemColMenu from './ItemColMenu'; 

const bem = bn.create('sidebar');

class Sidebar extends React.Component {

  constructor(props){
    super(props);

    this.state = { 
      ModuloAdministracion:this.agregarModuloAdministracion(), 
      navItems:this.agregarNavItems(),
      isOpenModuloEjemplos: false,
      isOpenModuloAdministracion: false,
    }; 

  }



  // funcion que arma arreglo navItems con los datos para el menu, se setea en el constructor porque se debe ejecutar antes del render
  agregarNavItems = () => {
    const {user} = this.props;

    const navItems = [{ to: '/inicio', name: 'Inicio', exact: true, Icon: MdDashboard }]; 

    if(user.permisos!==undefined){
      this.ver(navItems, { to: '/gestorBlog', name: 'Blog', exact: true, Icon: FaRegNewspaper }, user.permisos.mod_blog);
      this.ver(navItems, { to: '/gestorGaleria', name: 'Galerías', exact: true, Icon: FaImages }, user.permisos.mod_galeria);
      this.ver(navItems, { to: '/gestorCiclos', name: 'Ciclos', exact: true, Icon: FaBook }, user.permisos.mod_cursos);
      this.ver(navItems, { to: '/gestorAnuncios', name: 'Anuncios', exact: true, Icon: FaBullhorn }, user.permisos.mod_anuncios);
      this.ver(navItems, { to: '/gestorCalificaciones', name: 'Calificaciones', exact: true, Icon: FaStar }, user.permisos.mod_calificaciones);
      this.ver(navItems, { to: '/gestorMaterial', name: 'Subir material', exact: true, Icon: FaCloudUploadAlt }, user.permisos.mod_material);
      this.ver(navItems, { to: '/postulaciones', name: 'Postulaciones', exact: true, Icon: FaBookmark }, user.permisos.mod_postulaciones);
  
      this.ver(navItems, { to: '/estudianteAnuncios', name: 'Ver anuncios', exact: true, Icon: FaBullhorn }, user.permisos.mod_ver_anuncios);
      this.ver(navItems, { to: '/estudianteMaterial', name: 'Ver material académico', exact: true, Icon: FaCloudDownloadAlt }, user.permisos.mod_ver_material);
      this.ver(navItems, { to: '/estudianteCalificaciones', name: 'Ver calificaciones', exact: true, Icon: FaStar }, user.permisos.mod_ver_calificaciones);
    }
    


    return navItems; 

  }

   // funcion que arma arreglo ModuloAdministracion con los datos para el menu, se setea en el constructor porque se debe ejecutar antes del render
  agregarModuloAdministracion = () => {
    const {user} = this.props;

    const ModuloAdministracion = []; 

    if(user.permisos!==undefined){
      this.ver(ModuloAdministracion, { to: '/gestorUsuarios', name: 'Usuarios', exact: true, Icon: FaUserAlt }, user.permisos.mod_usuarios);
      this.ver(ModuloAdministracion, { to: '/gestorTipoUsuario', name: 'Tipo de usuario', exact: true, Icon: FaUnlock }, user.permisos.mod_tipousuarios);
      this.ver(ModuloAdministracion, { to: '/gestorEstudiantes', name: 'Estudiantes', exact: true, Icon: FaGraduationCap }, user.permisos.mod_estudiantes);
    }

    return ModuloAdministracion; 

  }


/*   componentDidMount(){
    const {navItems, ModuloAdministracion} = this.state; 
    if(navItems.length<=1){this.agregarNavItems()}
    if(ModuloAdministracion<1){this.agregarModuloAdministracion()}
  }
 */

  handleClick = name => () => {
    this.setState(prevState => {
      const isOpen = prevState[`isOpen${name}`];

      return {
        [`isOpen${name}`]: !isOpen,
      };
    });
  };


  ver = (arreglo, objeto, valor) => {

    if(valor==="1"){
      arreglo.push(objeto)
    }

    return arreglo
  }


  render() {
    
    const {ModuloAdministracion, navItems} = this.state; 


    return (

      
      <aside className={bem.b()} >

        <div className={bem.e('background')}  />

        <div className={bem.e('content')}>
          <Navbar>
              <img
                src={marca}
                width="200"
                height="auto"
                className="marca-menu"
                alt=""
              />
          </Navbar>
          <Nav vertical>
            {navItems.map(({ to, name, exact, Icon }, index) => (
              <NavItem key={index} className={bem.e('nav-item')}>
                <BSNavLink
                  id={`navItem-${name}-${index}`}
                  className=""
                  tag={NavLink}
                  to={to}
                  activeClassName="active"
                  exact={exact}
                >
                  <Icon className={bem.e('nav-item-icon')} />
                  <span className="">{name}</span>
                </BSNavLink>
              </NavItem>
            ))} 


            {/* SUB MENU ADMINISTRACION */}
             {ModuloAdministracion.length >0 && 
              <ItemColMenu
                titulo="Administración"
                nombre="ModuloAdministracion"
                isOpen={this.state.isOpenModuloAdministracion}
                handleClick={this.handleClick}
                modulo={ModuloAdministracion}
                Icon={FaCogs}
                classIcon=""
              /> 
          
            } 





          
          </Nav>

          
        </div>

        
      </aside>
    );
  }
}

export default Sidebar;
